import React from 'react';
import { Button, Grid, Typography } from '@mui/material';

const ResetForm = ({
    passwordValue,
    tokenValue,
    phoneError,
    handleChangePasswordValue,
    handleChangeTokenValue,
    handleResetPassword,
}) => {
    return (
        <Grid width="100%" mt="30px" bgcolor="white" p={{ xs: '30px 15px', sm: '30px' }} borderRadius="8px" mb="48px">
            <Grid display="flex" alignItems="center" justifyContent="center" mb="50px">
                <Typography variant="h2" color="#FDA058" fontWeight={700}>
                    تغییر رمز عبور
                </Typography>
            </Grid>
            <Grid mb="24px">
                <form style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="Password" style={{ marginBottom: '4px' }}>
                        رمز عبور جدید
                    </label>
                    <input
                        type="password"
                        id="Password"
                        name="Password"
                        value={passwordValue}
                        onChange={handleChangePasswordValue}
                        style={{
                            padding: '12px',
                            color: '#3C3D37',
                            borderRadius: '4px',
                            outline: 'none',
                            fontSize: '16px',
                        }}
                    />
                </form>
                {phoneError && (
                    <Typography variant="subtitle1" color="#B8001F" fontWeight={700}>
                        {phoneError}
                    </Typography>
                )}
            </Grid>
            <Grid mb="48px">
                <form style={{ display: 'flex', flexDirection: 'column' }}>
                    <label htmlFor="Token" style={{ marginBottom: '4px' }}>
                        کد تایید
                    </label>
                    <input
                        type="number"
                        id="Token"
                        name="Token"
                        value={tokenValue}
                        onChange={handleChangeTokenValue}
                        style={{
                            padding: '12px',
                            color: '#3C3D37',
                            borderRadius: '4px',
                            outline: 'none',
                            fontSize: '16px',
                        }}
                    />
                </form>
                {phoneError && (
                    <Typography variant="subtitle1" color="#B8001F" fontWeight={700}>
                        {phoneError}
                    </Typography>
                )}
            </Grid>
            <Button
                onClick={handleResetPassword}
                sx={{
                    bgcolor: '#FDA058',
                    borderRadius: '12px',
                    width: '100%',
                    p: '12px 0px',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 700,
                    boxShadow: 5,
                    mb: '36px',
                    '&:hover': { bgcolor: '#FF8343' },
                }}
            >
                تغییر رمز عبور
            </Button>
        </Grid>
    );
};

export default ResetForm;
